import ArrowForward from '@mui/icons-material/ArrowForward';

import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import CardActionArea from '@zenbusiness/zui/CardActionArea';
import CardContent from '@zenbusiness/zui/CardContent';
import CardMedia from '@zenbusiness/zui/CardMedia';
import Chip from '@zenbusiness/zui/Chip';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

import { BASE_STYLES } from '../utils/constants';

export const Root = superstyled({
  name: 'UpsellCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => {
    return {
      ...BASE_STYLES,
      width: '100%',
      textDecoration: 'none',
      borderRadius: theme.shape.borderRadius
    };
  }
});

export const ActionArea = superstyled({
  name: 'UpsellCard',
  slot: 'ActionArea',
  tag: CardActionArea,
  styles: ({ theme }) => ({
    padding: theme.spacing(3),
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    height: '100%'
  })
});

export const Content = superstyled({
  name: 'UpsellCard',
  slot: 'Content',
  tag: CardContent,
  styles: ({ theme }) => ({
    padding: theme.spacing(3),
    margin: 0,
    paddingBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  })
});

export const Title = superstyled({
  name: 'UpsellCard',
  slot: 'Title',
  tag: Text,
  styles: () => ({
    fontWeight: 600
  })
});

export const TitleContainer = superstyled({
  name: 'UpsellCard',
  slot: 'TitleContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // paddingBlock: theme.spacing(2),
    gap: theme.spacing(2),
    flex: 1
  })
});

export const SubtitleContainer = superstyled({
  name: 'UpsellCard',
  slot: 'SubtitleContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    // paddingBlock: theme.spacing(2),
    gap: theme.spacing(2),
    flex: 1
  })
});

export const Subtitle = superstyled({
  name: 'UpsellCard',
  slot: 'Subtitle',
  tag: Text,
  styles: () => ({
    // marginBottom: theme.spacing(1)
  })
});

export const Description = superstyled({
  name: 'UpsellCard',
  slot: 'Description',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  })
});

export const Badge = superstyled({
  name: 'UpsellCard',
  slot: 'Badge',
  tag: Chip,
  styles: ({ theme, partner }) => {
    // Partner-based badge styling
    // const borderColor = theme.palette.secondary.main;
    // let boxShadow = '0px 7px 18px 0px rgba(190, 212, 255, 0.50)';

    if (partner === 'Avalara') {
      // borderColor = theme.palette.primary.main;
      // boxShadow = '0px 7px 18px 0px rgba(63, 135, 245, 0.50)';
    }

    return {
      ...BASE_STYLES,
      padding: theme.spacing(1),
      minWidth: '6rem',
      minHeight: '6rem',
      borderRadius: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      // border: `1px solid ${borderColor}`,
      // background: theme.palette.background.paper,
      aspectRatio: '1/1'
      // boxShadow,
    };
  }
});

export const BadgeLabel = superstyled({
  name: 'UpsellCard',
  slot: 'BadgeLabel',
  tag: Text,
  styles: () => ({
    // fontSize: '0.75rem',
    // color: theme.palette.text.secondary,
    // marginTop: theme.spacing(0.5)
  })
});

export const PartnerContainer = superstyled({
  name: 'UpsellCard',
  slot: 'PartnerContainer',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2)
  })
});

export const PartnerLogo = superstyled({
  name: 'UpsellCard',
  slot: 'PartnerLogo',
  tag: SharedAsset,
  styles: () => ({
    height: 20,
    objectFit: 'contain'
  })
});

export const Media = superstyled({
  name: 'UpsellCard',
  slot: 'Media',
  tag: CardMedia,
  propsAdded: {
    component: 'figure'
  },
  styles: ({ theme }) => ({
    position: 'relative',
    marginBottom: theme.spacing(1)
  })
});

export const Image = superstyled({
  name: 'UpsellCard',
  slot: 'Image',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    alignSelf: 'center',
    borderRadius: theme.spacing(1),
    width: '100%',
    maxHeight: '200px',
    objectFit: 'cover'
  })
});

export const ImagePlaceholder = superstyled({
  name: 'UpsellCard',
  slot: 'ImagePlaceholder',
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    height: '200px',
    backgroundColor: '#f5f5f5',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(1)
  })
});

export const ButtonContainer = superstyled({
  name: 'UpsellCard',
  slot: 'ButtonContainer',
  tag: Box,
  styles: () => ({
    marginTop: 'auto'
  })
});

export const TextHighlight = superstyled({
  name: 'UpsellCard',
  slot: 'TextHighlight',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.secondary.main,
    fontWeight: 600
  })
});

export const ArrowForwardIcon = superstyled({
  name: 'UpsellCard',
  slot: 'ArrowForwardIcon',
  tag: ArrowForward,
  styles: ({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    color: theme.palette.secondary.main,
    transition: 'transform 0.3s ease',
    '.MuiButton-root:hover &': {
      transform: 'translateX(6px)'
    }
  })
});
